import { Grid, Box, Button } from "@mui/material"
import Typography from "@mui/material/Typography"
import Switch from "@mui/material/Switch"
import FormControlLabel from "@mui/material/FormControlLabel"
import TextField from "@mui/material/TextField"
import { Trash2 } from "lucide-react";
import Autocomplete from "@mui/material/Autocomplete"
import { Stack, CircularProgress, Modal } from "@mui/material"
import { IconButton, Divider } from "@mui/material";

import timestampToDate from "../../../../components/timestampToDate"
import { useEffect } from "react"

const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    bgcolor: "background.paper",
    boxShadow: 20,
    p: 4,
    minWidth: 850,
    maxWidth: 850,
    borderRadius: 3,
    position: "relative"
};

export default function InvoiceModal({
    open,
    handleClose,
    spiner,
    msgDangerModal,
    invoiceTypeSpecial,
    setInvoiceTypeSpecial,
    invoiceID,
    handleChangeInvoiceID,
    dateOriginalBill,
    dateBill,
    handleChageDate,
    listUserClient,
    defaultUserClientValueList,
    changeClient,
    servicioSeleccionado,
    setServicioSeleccionado,
    servicios,
    serviciosAñadidos,
    setServiciosAñadidos,
    tipoIva,
    setIvaType,
    iva,
    setIva,
    price,
    handleChangePrice,
    motivo,
    setMotivo,
    concepto,
    setConcepto,
    createInvoice,
    spinerModal,
    setInvoinceID,
    setDateOriginalBill,
    setDateBill,
    setDefaultUserClientValueList,
    setIsClientSelect,
    setIdClient,
    setPrice,
    invoiceShowPrice,
    setInvoiceShowPrice,
    subtotal
}) {

    useEffect(() => {
        const updated = serviciosAñadidos.map((serv, index) => {
            const price = calcularTotalServicios(serviciosAñadidos, index);
            if (serv.price !== price) return { ...serv, price };
            return serv;
        });

        const hasChanges = updated.some((serv, i) => serv.price !== serviciosAñadidos[i].price);
        if (hasChanges) {
            setServiciosAñadidos(updated);
        }

    }, [serviciosAñadidos, calcularTotalServicios]);

    useEffect(() => {
        const total = parseFloat(calcularTotalServicios(serviciosAñadidos).replace('.', '').replace(',', '.'));
        const tipo = parseFloat(tipoIva) || 0;
        const totalMasIva = total + (total * tipo / 100);
        handleChangePrice(totalMasIva);
    }, [serviciosAñadidos, tipoIva])


    useEffect(() => {
        const total = parseFloat(calcularTotalServicios(serviciosAñadidos).replace('.', '').replace(',', '.'));
        const tipo = parseFloat(tipoIva) || 0;
        const ivaSolo = total * tipo / 100;
        setIva(Math.round(ivaSolo * 100) / 100);
    }, [serviciosAñadidos, calcularTotalServicios, tipoIva]);

    return (
        <Modal
            open={open}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            className="text-center"
        >
            <Box sx={style}>
                <Typography id="modal-modal-title" variant="h6" component="h2">
                    Crear Nuevo Presupuesto
                </Typography>
                {!spiner && (
                    <>
                        <Stack spacing={2} mt={2}>
                            {msgDangerModal && (
                                <Grid item xs={12} md={12} lg={12}>
                                    <Box className="alert-danger">
                                        {msgDangerModal.map((item, index) => {
                                            return (<span key={index}>{item} <br /></span>)
                                        })}
                                    </Box>
                                </Grid>
                            )}

                            <Stack direction="row" spacing={2} alignItems="center" sx={{ width: '100%' }}>
                                <TextField
                                    name="dateBill"
                                    label="Día de emisión (Fecha)"
                                    variant="outlined"
                                    type="date"
                                    onChange={handleChageDate}
                                    value={dateBill || []}
                                    InputLabelProps={{ shrink: true }}
                                    size="small"
                                    sx={{ minWidth: 180, maxWidth: 220, flex: 1 }}
                                />
                                <Autocomplete
                                    options={listUserClient}
                                    value={defaultUserClientValueList}
                                    getOptionLabel={(option) => {
                                        if (Object.keys(option).length !== 0) {
                                            return `${option.name} ${option.surnames} ${option.email}`
                                        } else {
                                            return ""
                                        }
                                    }}
                                    renderInput={(params) => <TextField
                                        {...params}
                                        label="* Cliente"
                                        variant="outlined"
                                        name="idClient"
                                        InputLabelProps={{ shrink: true }}
                                        size="small"
                                    />}
                                    getOptionSelected={(option, value) => option.value === value.value}
                                    onChange={changeClient}
                                    disabled={invoiceTypeSpecial}
                                    sx={{ flex: 3 }}
                                />
                            </Stack>

                            {invoiceTypeSpecial && (

                                <TextField
                                    value={motivo}
                                    onChange={(e) => setMotivo(e.target.value)}
                                    variant="outlined"
                                    label="Motivo de la Factura de Abono"
                                    name="motivo"
                                    type="text"
                                    fullWidth
                                    size="small"
                                    InputLabelProps={{ shrink: true }}
                                    multiline
                                    rows={2}
                                />

                            )}

                            <TextField
                                value={concepto}
                                onChange={(e) => setConcepto(e.target.value)}
                                variant="outlined"
                                label="Concepto"
                                name="concepto"
                                type="text"
                                fullWidth
                                size="small"
                                InputLabelProps={{ shrink: true }}
                                multiline
                                rows={4}
                            />

                            {!invoiceTypeSpecial && (
                                <>
                                    <Stack direction="row" spacing={2} alignItems="center" sx={{ width: '100%' }}>
                                        {(() => {
                                            let tipoIvaActual = null;

                                            if (serviciosAñadidos.length > 0) {
                                                const firstWithIva = serviciosAñadidos.find(s => s.serviceType !== "MANUAL");
                                                if (firstWithIva) {
                                                    tipoIvaActual = String(firstWithIva.iva);
                                                } else {
                                                    tipoIvaActual = String(tipoIva);
                                                }
                                            }

                                            const serviciosFiltrados = tipoIvaActual !== null
                                                ? servicios.filter(s => String(s.iva) === tipoIvaActual)
                                                : servicios;

                                            const ivaLabel = tipoIvaActual !== null ? ` (IVA: ${tipoIvaActual}%)` : '';
                                            
                                            return (
                                                <Autocomplete
                                                    options={serviciosFiltrados}
                                                    getOptionLabel={(option) => option.name || ''}
                                                    value={servicioSeleccionado}
                                                    onChange={(event, value) => setServicioSeleccionado(value)}
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            variant="outlined"
                                                            label={`Servicio${ivaLabel}`}
                                                            placeholder="Selecciona un servicio"
                                                            fullWidth
                                                            size="small"
                                                        />
                                                    )}
                                                    sx={{ minWidth: 250, flex: 1 }}
                                                    disabled={serviciosFiltrados.length === 0}
                                                />
                                            );
                                        })()}

                                        <Button
                                            variant="outlined"
                                            color="primary"
                                            disabled={!servicioSeleccionado}
                                            onClick={() => {
                                                setServiciosAñadidos(prev => [
                                                    ...prev,
                                                    { ...servicioSeleccionado, date: '', qt: '' }
                                                ]);
                                                setServicioSeleccionado(null);
                                            }}
                                            sx={{ flex: 1, maxWidth: 100 }}
                                        >
                                            Añadir
                                        </Button>

                                        <Divider orientation="vertical" flexItem sx={{ mx: 1 }} />

                                        <Button
                                            variant="outlined"
                                            color="primary"
                                            sx={{ flex: 1, maxWidth: 140 }}
                                            onClick={() => {
                                                setServiciosAñadidos(prev => [
                                                    ...prev,
                                                    {
                                                        name: '', // Editable name
                                                        date: '',
                                                        qt: '',
                                                        unit: '',
                                                        pvp: '',
                                                        iva: tipoIva || '',
                                                        serviceType: 'MANUAL',
                                                        manual: true
                                                    }
                                                ]);
                                            }}
                                        >
                                            Línea manual
                                        </Button>
                                    </Stack>
            
                                    {/* Lista de servicios añadidos */}
                                    {serviciosAñadidos.length > 0 && (
                                        <>
                                            <Box
                                                sx={{
                                                    border: "1px solid #e0e0e0",
                                                    p: 2,
                                                    borderRadius: 2,
                                                    bgcolor: "#fafafa",
                                                    maxHeight: 220,
                                                    overflowY: "auto",
                                                    mt: 2,
                                                }}
                                            >
                                                {/* Header */}
                                                <Grid container sx={{ fontWeight: "bold", fontSize: 14, pb: 1 }}>
                                                    <Grid item xs={6} sx={{ textAlign: 'left' }}>Servicio</Grid>
                                                    <Grid item xs={2}>Fecha</Grid>
                                                    <Grid item xs={1}>Cantidad</Grid>
                                                    <Grid item xs={1}>Precio unidad</Grid>
                                                    <Grid item xs={1}>Precio línea</Grid>
                                                    <Grid item xs={1}></Grid>
                                                </Grid>

                                                <Divider />

                                                {/* Files */}
                                                {serviciosAñadidos.map((serv, idx) => {
                                                    const val = parseFloat(serv.qt);
                                                    const cantidadValida = !isNaN(val) && val > 0;
                                                    const pvpBase = parseFloat(serv.pvp) || 0;

                                                    // Càlcul total línia
                                                    let totalServicio = 0;
                                                    if (cantidadValida) {
                                                        if (serv.serviceType === 'KEY_UNIT') {
                                                            totalServicio = pvpBase * val;
                                                        } else if (serv.serviceType === 'KEY_TIME') {
                                                            totalServicio = pvpBase * (val / 60); // €/hora
                                                        } else {
                                                            totalServicio = pvpBase * val;
                                                        }
                                                    }

                                                    return (
                                                        <Box key={idx}>
                                                            <Grid container alignItems="center" sx={{ py: 1 }}>
                                                                {/* Nom servei */}
                                                                <Grid item xs={6}>
                                                                    {serv.manual ? (
                                                                        <TextField
                                                                            size="small"
                                                                            value={serv.name}
                                                                            onChange={e => {
                                                                                const nuevos = [...serviciosAñadidos];
                                                                                nuevos[idx].name = e.target.value;
                                                                                setServiciosAñadidos(nuevos);
                                                                            }}
                                                                            fullWidth
                                                                            label="Nombre servicio manual"
                                                                        />
                                                                    ) : (
                                                                        <Typography sx={{ whiteSpace: "normal", textAlign: "left" }}>
                                                                            {serv.name}
                                                                        </Typography>
                                                                    )}
                                                                </Grid>

                                                                {/* Data servei */}
                                                                <Grid item xs={2} sx={{ pr: 1 }}>
                                                                    <TextField
                                                                        type="date"
                                                                        fullWidth
                                                                        size="small"
                                                                        value={serv.date}
                                                                        InputLabelProps={{ shrink: true }}
                                                                        onChange={e => {
                                                                            const nuevos = [...serviciosAñadidos];
                                                                            nuevos[idx].date = e.target.value;
                                                                            setServiciosAñadidos(nuevos);
                                                                        }}
                                                                    />
                                                                </Grid>

                                                                {/* Qt / Unit */}
                                                                <Grid item xs={1}>
                                                                    {serv.serviceType === 'KEY_HOUER' ? (
                                                                        <TextField
                                                                            size="small"
                                                                            value={serv.qt}
                                                                            onChange={e => {
                                                                                const nuevos = [...serviciosAñadidos];
                                                                                const sanitizeNumericInput = (v) => {
                                                                                    if (v === undefined || v === null) return '';
                                                                                    let s = String(v).replace(/,/g, '.');
                                                                                    s = s.replace(/[^0-9.]/g, '');
                                                                                    const parts = s.split('.');
                                                                                    if (parts.length > 1) {
                                                                                        s = parts.shift() + '.' + parts.join('');
                                                                                    }
                                                                                    return s;
                                                                                };
                                                                                let value = sanitizeNumericInput(e.target.value);
                                                                                nuevos[idx].qt = value;
                                                                                nuevos[idx].unit = null;
                                                                                setServiciosAñadidos(nuevos);
                                                                            }}
                                                                            sx={{ width: "60px" }}
                                                                            InputLabelProps={{ shrink: true }}
                                                                            label={"m"}
                                                                        />
                                                                    ) : serv.manual ? (
                                                                        <TextField
                                                                            size="small"
                                                                            value={serv.qt}
                                                                            onChange={e => {
                                                                                const nuevos = [...serviciosAñadidos];
                                                                                const sanitizeNumericInput = (v) => {
                                                                                    if (v === undefined || v === null) return '';
                                                                                    let s = String(v).replace(/,/g, '.');
                                                                                    s = s.replace(/[^0-9.]/g, '');
                                                                                    const parts = s.split('.');
                                                                                    if (parts.length > 1) {
                                                                                        s = parts.shift() + '.' + parts.join('');
                                                                                    }
                                                                                    return s;
                                                                                };
                                                                                let value = sanitizeNumericInput(e.target.value);
                                                                                nuevos[idx].unit = value;
                                                                                nuevos[idx].qt = null;
                                                                                setServiciosAñadidos(nuevos);
                                                                            }}
                                                                            sx={{ width: "60px" }}
                                                                            InputLabelProps={{ shrink: true }}
                                                                            label={"unit"}
                                                                        />
                                                                    ) : (
                                                                        <TextField
                                                                            size="small"
                                                                            value={serv.unit}
                                                                            onChange={e => {
                                                                                const nuevos = [...serviciosAñadidos];
                                                                                const sanitizeNumericInput = (v) => {
                                                                                    if (v === undefined || v === null) return '';
                                                                                    let s = String(v).replace(/,/g, '.');
                                                                                    s = s.replace(/[^0-9.]/g, '');
                                                                                    const parts = s.split('.');
                                                                                    if (parts.length > 1) {
                                                                                        s = parts.shift() + '.' + parts.join('');
                                                                                    }
                                                                                    return s;
                                                                                };
                                                                                let value = sanitizeNumericInput(e.target.value);
                                                                                nuevos[idx].unit = value;
                                                                                nuevos[idx].qt = null;
                                                                                setServiciosAñadidos(nuevos);
                                                                            }}
                                                                            sx={{ width: "60px" }}
                                                                            InputLabelProps={{ shrink: true }}
                                                                            label={"unit"}
                                                                        />
                                                                    )}
                                                                </Grid>

                                                                {/* Total línia editat i recalcul PVP */}
                                                                <Grid item xs={1}>
                                                                    {serv.manual ? (
                                                                        <TextField
                                                                            size="small"
                                                                            value={serv.pvp}
                                                                            onChange={e => {
                                                                                const nuevos = [...serviciosAñadidos];
                                                                                const sanitizeNumericInput = (v) => {
                                                                                    if (v === undefined || v === null) return '';
                                                                                    let s = String(v).replace(/,/g, '.');
                                                                                    s = s.replace(/[^0-9.]/g, '');
                                                                                    const parts = s.split('.');
                                                                                    if (parts.length > 1) {
                                                                                        s = parts.shift() + '.' + parts.join('');
                                                                                    }
                                                                                    return s;
                                                                                };
                                                                                nuevos[idx].pvp = sanitizeNumericInput(e.target.value);
                                                                                setServiciosAñadidos(nuevos);
                                                                            }}
                                                                            sx={{ minWidth: 60 }}
                                                                            label="PVP"
                                                                        />
                                                                    ) : (
                                                                        <Typography sx={{ minWidth: 60 }}>{ serv.pvp }</Typography>
                                                                    )}
                                                                </Grid>

                                                                <Grid item xs={1}>
                                                                    {calcularTotalServicios(serviciosAñadidos, idx)} €
                                                                </Grid>

                                                                {/* Eliminar */}
                                                                <Grid item xs={1}>
                                                                    <IconButton
                                                                        onClick={() => setServiciosAñadidos(prev => prev.filter((_, i) => i !== idx))}
                                                                        color="error"
                                                                        size="small"
                                                                    >
                                                                        <Trash2 size={18} />
                                                                    </IconButton>
                                                                </Grid>
                                                            </Grid>

                                                            {idx < serviciosAñadidos.length - 1 && <Divider />}
                                                        </Box>
                                                    );
                                                })}
                                            </Box>
                                            
                                            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: "10px" }}>
                                                <Box style={{
                                                    fontSize: 16,
                                                    fontWeight: 500,
                                                    color: "#222",
                                                    marginLeft: 18
                                                }}>
                                                    <span style={{ fontWeight: 700, color: '#1976d2' }}>Subtotal</span>: {calcularTotalServicios(serviciosAñadidos)} €
                                                    
                                                    &nbsp;<span style={{ color: '#bbb' }}>|</span>&nbsp;
                                                    
                                                    <span style={{ fontWeight: 700, color: '#ff9800' }}>IVA</span>: {(() => {
                                                        const total = parseFloat(calcularTotalServicios(serviciosAñadidos).replace('.', '').replace(',', '.'));
                                                        const tipo = parseFloat(tipoIva) || 0;
                                                        const ivaSolo = total * tipo / 100;
                                                        return ivaSolo.toLocaleString('es-ES', {
                                                            minimumFractionDigits: 2,
                                                            maximumFractionDigits: 2
                                                        });
                                                    })()} €

                                                    &nbsp;<span style={{ color: '#bbb' }}>|</span>&nbsp;

                                                    <span style={{ fontWeight: 700, color: '#388e3c' }}>Total</span>: {(() => {
                                                        const total = parseFloat(calcularTotalServicios(serviciosAñadidos).replace('.', '').replace(',', '.'));
                                                        const tipo = parseFloat(tipoIva) || 0;
                                                        const totalMasIva = total + (total * tipo / 100);
                                                        return totalMasIva.toLocaleString('es-ES', {
                                                            minimumFractionDigits: 2,
                                                            maximumFractionDigits: 2
                                                        });
                                                    })()} €
                                                </Box>

                                                <Stack direction="row" alignItems="center" justifyContent="center" spacing={2}>
                                                    <Typography>Mostrar precio en línea</Typography>
                                                    <FormControlLabel
                                                        control={
                                                            <Switch
                                                                checked={invoiceShowPrice}
                                                                onChange={(event, value) => {
                                                                    setInvoiceShowPrice(value)
                                                                }}
                                                                color="primary"
                                                            />
                                                        }
                                                    />
                                                </Stack>
                                            </div>
                                        </>
                                    )}
                                </>
                            )}

                            <hr />

                            <Stack direction="row" spacing={2}>
                                <TextField
                                    value={iva}
                                    onChange={(e) => setIva(e.target.value)}
                                    disabled={true}
                                    variant="outlined"
                                    label="IVA (€)"
                                    name="iva"
                                    type="number"
                                    fullWidth
                                    size="small"
                                    InputLabelProps={{ shrink: true }}
                                />
                                <TextField
                                    value={tipoIva}
                                    onChange={(e) => setIvaType(e.target.value)}
                                    disabled={serviciosAñadidos.find(s => s.serviceType !== "MANUAL")}
                                    variant="outlined"
                                    label="Tipo de IVA (%)"
                                    name="iva"
                                    type="number"
                                    size="small"
                                    InputLabelProps={{ shrink: true }}
                                    style={{ maxWidth: 180 }}
                                />
                            </Stack>

                            <TextField
                                value={price}
                                onChange={(e) => handleChangePrice(e.target.value)}
                                variant="outlined"
                                label="Total con IVA (€)"
                                name="price"
                                type="number"
                                fullWidth
                                size="small"
                                InputLabelProps={{ shrink: true }}
                            />

                            <Stack direction="row" justifyContent="space-between">
                                <div style={{ display: "flex", justifyContent: "flex-end", width: "100%", gap: 16 }}>
                                    <div style={{ width: "50%" }}>
                                        <Button
                                            onClick={handleClose}
                                            variant="contained"
                                            className="MuiButton-containedCancel"
                                            fullWidth
                                        >
                                            Cancelar
                                        </Button>
                                    </div>
                                    <div style={{ width: "50%" }}>
                                        <Button
                                            onClick={createInvoice}
                                            color="primary"
                                            variant="contained"
                                            fullWidth
                                        >
                                            Crear Presupuesto
                                        </Button>
                                    </div>
                                </div>
                            </Stack>
                        </Stack>
                    </>
                )}

                {spiner && (
                    <>
                        <br />
                        <br />
                        <br />
                        <CircularProgress color="success" />
                        <br />
                        <br />
                        <br />
                    </>
                )}
            </Box>
        </Modal>
    );
}

// Calcula el total de los servicios añadidos o de una posición específica
function calcularTotalServicios(serviciosAñadidos, index = null) {
    const parseNumber = (v) => {
        if (v === undefined || v === null || v === '') return NaN;
        const s = String(v).replace(/\s/g, '').replace(/,/g, '.');
        const n = parseFloat(s);
        return isNaN(n) ? NaN : n;
    };

    const isHourType = (t) => t === 'KEY_HOUER' || t === 'KEY_TIME';

    // Si se indica un índice, calcula solo esa posición
    if (index !== null && typeof index === 'number' && serviciosAñadidos[index]) {
        const serv = serviciosAñadidos[index];
        const val = parseNumber(serv.qt ?? serv.unit);
        if (isNaN(val) || val <= 0) return '0.00';
        const pvp = parseNumber(serv.pvp) || 0;
        let total = 0;
        if (serv.serviceType === 'KEY_UNIT') {
            total = pvp * val;
        } else if (isHourType(serv.serviceType)) {
            total = pvp * (val / 60);
        } else {
            total = pvp * val;
        }
        return total.toLocaleString('es-ES', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        });
    }

    // Si no, calcula el total acumulado
    const total = serviciosAñadidos.reduce((acc, serv) => {
        const val = parseNumber(serv.qt ?? serv.unit);
        if (isNaN(val) || val <= 0) return acc;
        const pvp = parseNumber(serv.pvp) || 0;
        if (serv.serviceType === 'KEY_UNIT') {
            return acc + (pvp * val);
        } else if (isHourType(serv.serviceType)) {
            return acc + (pvp * (val / 60));
        }
        return acc + (pvp * val);
    }, 0);

    return total.toLocaleString('es-ES', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    });
}